/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import React from "react"
import { SectionGrid, Grid, Flex } from "frontend/src/components/Layout"
import Img from "gatsby-image"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"
import { BlockText } from "frontend/src/components/BlockText"
import { theme } from "frontend/src/utils/theme"

const fs = number => `${theme.fontSizes[number]}px`
const fw = name => theme.fontWeights[name]
const ff = name => theme.fonts[name]

function HeroDesktop({ image, side, text, backgroundTextBlock }) {
  const imagePosition = side === "imageLeft" ? "1 / span 1" : "2 / span 1"
  const textPosition = side === "imageLeft" ? "2 / span 1" : "1 / span 1"
  return (
    <Grid columns="1fr 1fr" gap="0" sx={{ width: "100%", display: ["none", "none", "grid"] }}>
      <Img
        fluid={getFluidFromAsset(image, 4000)}
        sx={{ width: "100%", height: "350px", gridColumn: imagePosition, gridRow: "1 / span 1" }}
      />
      <Flex
        direction="column"
        align="flex-start"
        justify="center"
        sx={{
          width: "100%",
          gridColumn: textPosition,
          gridRow: "1 / span 1",
          backgroundColor: backgroundTextBlock,
        }}
      >
        <div sx={{ width: "71%", minWidth: "326px", maxWidth: "508px", mx: "auto" }}>
          <BlockText
            blocks={text}
            style={{
              fontFamily: ff("heading"),
              fontWeight: fw("regular"),
              fontSize: fs(7),
              lineHeight: 1.29,
              letterSpacing: "-1px",
            }}
          />
        </div>
      </Flex>
    </Grid>
  )
}

function HeroMobile({ image, side, text, textMobile, backgroundTextBlock }) {
  const imagePosition = side === "imageLeft" ? "1 / span 1" : "2 / span 1"
  const textPosition = side === "imageLeft" ? "2 / span 1" : "1 / span 1"
  return (
    <Grid columns="1fr 1fr" gap="0" sx={{ width: "100%", display: ["grid", "grid", "none"] }}>
      <Img
        fluid={getFluidFromAsset(image, 4000)}
        sx={{
          width: "100%",
          height: ["145px", "230px"],
          gridColumn: imagePosition,
          gridRow: "1 / span 1",
        }}
      />
      <Flex
        direction="column"
        align="flex-start"
        justify="center"
        sx={{
          width: "100%",
          gridColumn: textPosition,
          gridRow: "1 / span 1",
          backgroundColor: backgroundTextBlock,
        }}
      >
        <div
          sx={{
            mx: "auto",
            width: ["70%", "77%"],
            minWidth: ["80px", "212px"],
            maxWidth: ["90px", "251px"],
          }}
        >
          <BlockText
            blocks={text}
            style={{
              fontFamily: ff("heading"),
              fontWeight: fw("regular"),
              fontSize: fs(3),
              lineHeight: 1.3,
              letterSpacing: "-1px",
              display: ["none", "block"],
            }}
          />
          <BlockText
            blocks={textMobile}
            style={{
              fontFamily: ff("heading"),
              fontWeight: fw("regular"),
              fontSize: fs(0),
              lineHeight: 1.29,
              letterSpacing: "-1px",
              display: ["block", "none"],
            }}
          />
        </div>
      </Flex>
    </Grid>
  )
}

function HeroElement({ desktop, mobile, side, text, textMobile, backgroundTextBlock }) {
  return (
    <React.Fragment>
      <HeroDesktop
        image={desktop}
        side={side}
        text={text}
        backgroundTextBlock={backgroundTextBlock}
      />
      <HeroMobile
        image={mobile}
        side={side}
        text={text}
        textMobile={textMobile}
        backgroundTextBlock={backgroundTextBlock}
      />
    </React.Fragment>
  )
}

function HeroBlockImage({
  imageDesktop,
  imageMobile,
  text,
  textMobile,
  imageSide,
  width,
  backgroundTextBlock,
}) {
  if (width === "full") {
    return (
      <div sx={{ width: "100%" }}>
        <HeroElement
          text={text}
          textMobile={textMobile}
          desktop={imageDesktop}
          mobile={imageMobile}
          side={imageSide}
          backgroundTextBlock={backgroundTextBlock}
        />
      </div>
    )
  }
  const Element = width === "wide" ? SectionGrid.wide : SectionGrid.narrow
  return (
    <SectionGrid>
      <Element>
        <HeroElement
          text={text}
          textMobile={textMobile}
          desktop={imageDesktop}
          mobile={imageMobile}
          side={imageSide}
          backgroundTextBlock={backgroundTextBlock}
        />
      </Element>
    </SectionGrid>
  )
}

export { HeroBlockImage }
